import type { QueryClient } from "@tanstack/react-query";

export function invalidatePermitSuitePipeline(queryClient: QueryClient, municipalityId: number) {
  queryClient.invalidateQueries({ queryKey: ["permit_applications", municipalityId] });
}
